<!--首页banner图-->
<template>
  <div class="indexTopBanner" :option="option">
    <template v-if="option.length != 0">
      <div class="home-to-banner" v-if="option.length <= 1">
        <img  class="pointer" @click="goSearchList(option[0])" :src="getImg(option[0])"/>
      </div>
      <!-- <div class="home-to-banner" v-else  @mouseenter="on_top_enter" @mouseleave="on_top_leave"> -->
      <div class="home-to-banner" v-else>
        <swiper :options="swiperOption" class="swiper-container-topBanner" ref="mySwiper">
          <swiper-slide class="swiper-slide-topBanner" v-for="(item, index) in option" :key="index">
            <img  class="pointer" :options="JSON.stringify(item)" :src="getImg(item)" />
          </swiper-slide>
        </swiper>
      </div>
    </template>
    <div class="home-to-banner"  v-else>
      <a href="#" @click="goLogin()" v-if="oWidth>750"><img  class="pointer" :src="homeBanner"/></a>
      <a href="#" @click="goLogin()" v-if="oWidth<=750"><img  class="pointer" :src="mobileHomeBanner"/></a>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import homeBanner from '@/assets/homeImages/banner.jpg'
import mobileHomeBanner from '@/assets/images/mobile/banner.jpg'
import mobileHomeBanner1 from '@/assets/images/mobile/banner1.jpg'

let vm = null
export default {
  props: {
    option: {
      type: [Object, String, Array],
      default: () => ''
    }
  },
  components: {},
  data() {
    return {
      oWidth: document.body.clientWidth,
      homeBanner:homeBanner,
      mobileHomeBanner:mobileHomeBanner,
      mobileHomeBanner1:mobileHomeBanner1,
      swiperOption: {
        loop: true,
        lazy: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        on: {
          click: function(e) {
            let options = e.target.getAttribute('options')
            if (!options) return
            options = JSON.parse(options)
            vm.goSearchList(options)
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['subjectType', 'isLogin', 'language']),
    mySwiper() {
      // mySwiper 是要绑定到标签中的ref属性
      return this.$refs.mySwiper.swiper
    },
  },
  mounted() {
    vm = this
  },
  methods: {
    getImg(data) {
      return data.coverIcon
        // return this.language === 'zh' ? (data.coverIcon || data.coverIconEn) : (data.coverIconEn || data.coverIcon)
    },
    on_top_enter() {
      this.mySwiper.autoplay.stop()
    },
    on_top_leave() {
      this.mySwiper.autoplay.start()
    },
    goLogin(){
      if (this.subjectType == '') {
        this.$store.commit('SET_SUBJECTTYPE', '')
        this.loginSource()
      }
    },
    goSearchList(param){
      window.PC.$RangersEvent("home_banner_click", {
        banner_id: param.id
      })
      let status = this.$config.settings.onlayReg2
      if (!status) {
        this.commonStatistics('001034000', param)
      }
      /**
       * EXTERNAL       外部链接（暂时不用）
       * PC_TOP_BANNER  pc接口取的参数
       * ACTOR_DETAILS  展商详情
       * TAG_EXHIBITOR  展商列表
       */
      if (param.urlType == 'PC_TOP_BANNER' || param.urlType == 'EXTERNAL') {
        if(param.url != '') {
          window.open(param.url, '_blank')
        }
       
      } else if (param.urlType == '') {
        if (param.isLogin && this.isLogin !== '1') {
          this.goLogin()
        }
      } else {
        if (status) {
          this.goLogin()
          return 
        }
        if (param.urlType=="ACTOR_DETAILS"){
          this.pageDetail(param, 'actor')
        } else if (param.urlType == "TAG_EXHIBITOR"){
          sessionStorage.setItem('findListActor',param.url)
          this.$router.push({ path: '/find/actor' })
        }  else if (param.urlType == "TAG_PRODUCT"){
          this.$router.push({ path: '/find/product', query: {type: param.url} })
        }else {
          console.log('暂时没有匹配操作')
        }

      }

    }
  }
}
</script>

<style lang="stylus" scoped>
  img{
    width 100%
    object-fit cover
  }
</style>
